import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { GetAllTrucksUseCase } from "../../../domain/usecase/truck/getAll/UseCase";
import { FilterTrucksByModel, Truck } from "../../../domain/model/Truck";
import { State } from "../../../domain/model/ResponseState";
import { all } from "axios";
import { GenerateXmlFileUseCase } from "../../../domain/usecase/truck/generateXmlFile/UseCase";
import { showGlobalLoadingView } from "../../../core/utils/Utils";

import fileSaver from "file-saver";

export function HomeViewModel(
  getAllTrucksUseCase: GetAllTrucksUseCase,
  generateXmlFileUseCase: GenerateXmlFileUseCase
) {
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setLoading] = useState(false);
  const [trucks, setTrucks] = useState<Array<Truck> | undefined>([]);

  const [truckFilteringModel, setTruckFilteringModel] = useState<
    FilterTrucksByModel | undefined
  >();

  const [allSelected, setAllSelected] = useState(true);

  const [showLoadMoreButton, setShowLoadMoreButton] = useState(false);
  const [showLoadMoreLoading, setShowLoadMoreLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const limit = 50;

  useEffect(() => {
    if (skip == 0) getAllTrucks();
  }, [skip]);

  function onFilterClicked() {
    if (truckFilteringModel) {
      setTrucks([]);
      setSkip(0);
    }
  }

  function onTruckChecked(checked: boolean, id: string) {
    if (!trucks) return;
    const newTrucks = [...trucks];
    newTrucks.map((t) => {
      if (t._id == id) {
        t.selected = checked;
      }
    });
    setTrucks(newTrucks);
  }

  function selectUnselectAll() {
    if (!trucks) return;
    const newTrucks = [...trucks];
    newTrucks.map((t) => {
      t.selected = !allSelected;
    });
    setTrucks(newTrucks);
    setAllSelected(!allSelected);
  }

  async function generateXmlFile(bool?: boolean) {
    var ids = undefined;
    if (!bool) {
      ids = trucks?.filter((t) => t.selected != false).flatMap((t) => t._id);
    }
    if (!ids && !bool) return;
    showGlobalLoadingView(true);
    const response = await generateXmlFileUseCase.invoke(truckFilteringModel, ids);
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;

        const downloadLink = response.data.downloadLink;

        fileSaver.saveAs(
          downloadLink,
          downloadLink.split("/")[downloadLink.split("/").length - 1]
        );
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function getAllTrucks() {
    if (skip == 0) setLoading(true);
    else setShowLoadMoreLoading(true);

    const response = await getAllTrucksUseCase.invoke(
      skip,
      limit,
      truckFilteringModel
    );
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        if (response.data.length == 0) setShowLoadMoreButton(false);
        else setShowLoadMoreButton(true);
        setTrucks(trucks?.concat(response.data));
        setSkip(skip + limit);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
    setShowLoadMoreLoading(false);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    isLoading,
    trucks,
    showLoadMoreButton,
    showLoadMoreLoading,
    getAllTrucks,
    truckFilteringModel,
    setTruckFilteringModel,
    onFilterClicked,
    onTruckChecked,
    selectUnselectAll,
    generateXmlFile,
  };
}
